/**
 * @generated SignedSource<<9a17e0f9ce9dda8401ff7c3882ddc110>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnableOrDisableTeamSyncForEventInput = {
  calendarId: string;
  clientMutationId?: string | null;
  disable: boolean;
  externalEventId: string;
  orgRelayId: string;
};
export type EnableOrDisableTeamSyncForEventMutation$variables = {
  input: EnableOrDisableTeamSyncForEventInput;
};
export type EnableOrDisableTeamSyncForEventMutation$data = {
  readonly enableOrDisableTeamSyncForEvent: {
    readonly disabled: boolean;
  } | null;
};
export type EnableOrDisableTeamSyncForEventMutation = {
  variables: EnableOrDisableTeamSyncForEventMutation$variables;
  response: EnableOrDisableTeamSyncForEventMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnableOrDisableTeamSyncForEventPayload",
    "kind": "LinkedField",
    "name": "enableOrDisableTeamSyncForEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EnableOrDisableTeamSyncForEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EnableOrDisableTeamSyncForEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9671b7d4601b10b117c00ae697f725e8",
    "id": null,
    "metadata": {},
    "name": "EnableOrDisableTeamSyncForEventMutation",
    "operationKind": "mutation",
    "text": "mutation EnableOrDisableTeamSyncForEventMutation(\n  $input: EnableOrDisableTeamSyncForEventInput!\n) {\n  enableOrDisableTeamSyncForEvent(input: $input) {\n    disabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d8c80d9e44c6799f7f9477dd659cba0";

export default node;
